// extracted by mini-css-extract-plugin
export default {"uploadButton":"FileUploadButton_uploadButton__Vbk87","uploadIcon":"FileUploadButton_uploadIcon__UX2nF"};